export default "__VITE_ASSET__DubRBUNV__"